const LOGO_FONT = 34
const CATEGORY = 28
const NORMAL = 14

export {
  LOGO_FONT,
  CATEGORY,
  NORMAL
}